'use strict';

if (!Array.prototype.includes) {
  require('core-js/fn/array/includes');
}

function duplicates(array) {
  var identity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (i) {
    return i;
  };

  var unique = [];
  var duplicates = [];
  array.forEach(function (item) {
    if (unique.includes(identity(item))) {
      duplicates.push(item);
    } else {
      unique.push(identity(item));
    }
  });
  return duplicates;
}

module.exports = duplicates;


//////////////////
// WEBPACK FOOTER
// ./node_modules/array-duplicates/dist/index.js
// module id = 385
// module chunks = 0